import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_RatingQuestion.scss'
import { Row, Col } from 'react-bootstrap'
import RatingInput from '../../../common/RatingInput'
import PropTypes from 'prop-types';

class RatingQuestion extends React.Component {
  static propTypes = {
    setRating: PropTypes.func.isRequired,
    ratingType: PropTypes.string.isRequired,
    question: PropTypes.string.isRequired
  }

  render () {
    return <div className={styles['rate-div']}>
      <Row>
        <Col xs={12} sm={12} className="d-block d-md-none" >
          <div className={styles['rate-div-input']}>
            <p className={styles['rating-question']}>{this.props.question}</p>
            <RatingInput
              setRating={this.props.setRating}
              ratingType={this.props.ratingType}
              grayed
            />
          </div>
        </Col>

        <Col md={4} lg={4} className="d-none d-md-block">
          <div className={styles['rate-div-input']}>
            <RatingInput
              setRating={this.props.setRating}
              ratingType={this.props.ratingType}
              grayed
            />
          </div>
        </Col>
        <Col md={8} lg={8} className="d-none d-md-block" >
          <p className={styles['rating-question']}>{this.props.question}</p>
        </Col>
      </Row>
    </div>
  }
}

export default  (RatingQuestion)
